import React, { useState, useEffect } from "react";
import "./Stories.css";
import { Scrollbars } from "react-custom-scrollbars";
import Calendar from "../Dashoard/Calander";
import MaskUser from "../Dashoard/MaskUser";
import ViewAll from "../Dashoard/ViewAll";
import MiniCard from "../Dashoard/MiniCard";
import { cardlisting } from "../../constant/commonUtils";
import commonApi from "../../CommonApi/CommonServices";
import { useDispatch, useSelector } from "react-redux";
import { errorMessage, successMessage } from "../../Errors/Toast";
import SpinnerLoader from "../../webLoader/SpinnerLoader";
import PricingModal from "../Modals/PricingModal";

const Stories = (props) => {
  const { spinnerLoader, setSpinnerLoader } = props;
  const [faqData, setFaqData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [editedAnswer, setEditedAnswer] = useState("");
  const [tabType, setTabtype] = useState("story_questions");
  const [storyText, setStoryText] = useState("");
  const [storySummary, setStorySummary] = useState("");
  const tokenSelector = useSelector((state) => state.rootReducer?.user?.token);
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (tabType === "story_questions") {
      get_stories();
    } else if (tabType === "story") {
      get_story_summary();
    }
  }, [tabType]);

  const toggleCollapse = (index) => {
    const currentElement = document.getElementById(`faqCollapse-${index + 1}`);
    const activeElement =
      activeIndex !== null
        ? document.getElementById(`faqCollapse-${activeIndex + 1}`)
        : null;

    if (activeIndex === index) {
      // Slide Up
      currentElement.style.height = `${currentElement.scrollHeight}px`; // Set to full height first
      setTimeout(() => {
        currentElement.classList.add("slide-up");
        currentElement.style.height = "0"; // Collapse
      }, 10);
      setTimeout(() => {
        currentElement.classList.remove("show", "slide-up");
        currentElement.style.height = "auto";
        setActiveIndex(null);
      }, 500);
    } else {
      if (activeElement) {
        // Slide Up previous active element
        activeElement.style.height = `${activeElement.scrollHeight}px`; // Set to full height first
        setTimeout(() => {
          activeElement.classList.add("slide-up");
          activeElement.style.height = "0"; // Collapse previous
        }, 10);
        setTimeout(() => {
          activeElement.classList.remove("show", "slide-up");
          activeElement.style.height = "auto";
        }, 500);
      }

      // Slide Down new element
      currentElement.style.height = "0"; // Set initial height to 0
      currentElement.classList.add("show", "slide-down");
      setTimeout(() => {
        currentElement.style.height = `${currentElement.scrollHeight}px`; // Set to full height
      }, 10);
      setTimeout(() => {
        currentElement.style.height = "auto"; // Allow it to expand naturally
      }, 500);
      setActiveIndex(index);
    }
  };
  const handleEdit = (id) => {
    // Find the index of the FAQ item with the matching id
    const index = faqData.findIndex((faq) => faq.id === id);

    // Check if a matching FAQ was found
    if (index !== -1) {
      setEditIndex(index); // Set the index for editing
      setEditedAnswer(faqData[index].answer);
      // Set the current answer for editing
    } else {
      // console.error("FAQ item with the specified ID not found.");
    }
  };

  const handleSave = (id) => {
    if (!editedAnswer.trim()) {
      errorMessage("Please enter a valid answer.");
      return;
    }
    const updatedFaqData = faqData.map((item) =>
      item.id === id ? { ...item, answer: editedAnswer } : item
    );

    setFaqData(updatedFaqData); // Update the FAQ data with the new answer
    setEditIndex(null); // Reset the edit mode
    add_stories(editedAnswer, id);
  };

  const handleChange = (e) => {
    setEditedAnswer(e.target.value);
  };

  const add_stories = (ans, id) => {
    // const formData = new FormData();
    // formData.append("story_id", id);
    // formData.append("response", ans);

    const paylaod = {
      story_id: id,
      response: ans,
    };
    commonApi
      .add_stories(paylaod, tokenSelector)
      .then((res) => {
        if (res.status === 200 && res.success === true) {
          successMessage(res.message);
        }
      })
      .catch((err) => {
        console.log("Err", err);
        return { type: "error", message: err.message };
      });
  };
  const get_stories = () => {
    const formData = new FormData();

    commonApi
      .get_stories(formData, tokenSelector)
      .then((res) => {
        if (res.status === 200 && res.success === true) {
          setFaqData(res.users);
          setTimeout(() => {
            setSpinnerLoader(false);
          }, 300);
        }
      })
      .catch((err) => {
        console.log("Err", err);
        setSpinnerLoader(false);
        return { type: "error", message: err.message };
      });
  };

  const get_story_summary = () => {
    commonApi
      .get_story_summary("", tokenSelector)
      .then((res) => {
        if (res.status === 200 && res.success === true) {
          if (res.story && Object.entries(res.story)?.length > 0) {
            setStorySummary(res.story.summary);
            setStoryText(res.story.story);
          }
          setTimeout(() => {
            setSpinnerLoader(false);
          }, 300);
        }
      })
      .catch((err) => {
        console.log("Err", err);
        setSpinnerLoader(false);
        return { type: "error", message: err.message };
      });
  };

  const save_story_summary = () => {
    setSpinnerLoader(true);
    const paylaod = {
      story: storyText,
      summary: storySummary,
    };

    commonApi
      .save_story_summary(paylaod, tokenSelector)
      .then((res) => {
        if (res.status === 200 && res.success === true) {
          successMessage(res.message);
        }
        setTimeout(() => {
          setSpinnerLoader(false);
        }, 300);
      })
      .catch((err) => {
        console.log("Err", err);
        setSpinnerLoader(false);
        return { type: "error", message: err.message };
      });
  };

  const regenerate_story = () => {
    setSpinnerLoader(true);
    commonApi
      .regenerate_story("", tokenSelector)
      .then((res) => {
        if (res.status === 200 && res.success === true) {
          setStorySummary(res.summary);
          setStoryText(res.story);
          successMessage(res.message);

          setTimeout(() => {
            setSpinnerLoader(false);
          }, 300);
        } else {
          if (res.token === false) {
            setShowModal(true);
            // errorMessage("Insufficient token.");
          } else {
            errorMessage(res.message);
          }
          setSpinnerLoader(false);
        }
      })
      .catch((err) => {
        console.log("Err", err);
        setSpinnerLoader(false);
        return { type: "error", message: err.message };
      });
  };

  const tabs = [
    { name: "Story Questions", id: "story_questions" },
    { name: "Story", id: "story" },
  ];

  return (
    <>
      <div className="faq-section">
        <div className="container">
          <div className="row faq-tab">
            <div className="col-md-9 col-sm-9 pe-4 story-according">
              <section className="faq-page">
                <div
                  className="position-relative faq dashboard-tab-section"
                  id="accordion"
                >
                  <div className="d-flex flex-wrap align-items-center gap-3 justify-content-between dashboard-name-section">
                    <ul className="nav nav-tabs border-0 gap-3">
                      {tabs.map((item, idx) => (
                        <li
                          className="nav-item"
                          key={idx}
                          onClick={() => {
                            setTabtype(item.id);
                            setSpinnerLoader(true);
                          }}
                        >
                          <a
                            className={`nav-link ${
                              item.id === tabType && "active"
                            } p-0 as-link`}
                          >
                            {item.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                    {tabType === "story" && (
                      <div className="tab-dropdown-listing d-flex gap-3 align-items-center justify-content-center">
                        <button
                          className="custm-selct-icon-btn btn btn-primary btn-md mt-0 mr-5"
                          type="button"
                          style={{
                            cursor: spinnerLoader ? "default" : "pointer",
                          }}
                          onClick={() => {
                            if (!spinnerLoader) {
                              regenerate_story();
                            }
                          }}
                        >
                          Regenerate
                        </button>
                      </div>
                    )}
                  </div>
                  {/* <div className="faq-title text-center">
                    <h2>Story</h2>
                  </div> */}
                  <div className="position-relative">
                    {spinnerLoader && <SpinnerLoader color="white" />}
                    {tabType === "story_questions" && faqData.length > 0
                      ? faqData.map((faq, index) => (
                          <div className="card" key={index}>
                            <div
                              className="card-header"
                              id={`faqHeading-${index + 1}`}
                            >
                              <div className="mb-0">
                                <h5
                                  className="faq-title"
                                  onClick={() => toggleCollapse(index)}
                                  data-toggle="collapse"
                                  data-target={`#faqCollapse-${index + 1}`}
                                  aria-expanded={activeIndex === index}
                                  aria-controls={`faqCollapse-${index + 1}`}
                                >
                                  <span className="badge">{index + 1}</span>{" "}
                                  {faq.question}
                                </h5>
                              </div>
                            </div>
                            <div
                              id={`faqCollapse-${index + 1}`}
                              className={`collapse ${
                                activeIndex === index ? "show slide-down" : ""
                              }`}
                              aria-labelledby={`faqHeading-${index + 1}`}
                              data-parent="#accordion"
                            >
                              <div
                                className="card-body"
                                style={{ padding: "10px 30px 10px 70px" }}
                              >
                                {editIndex === index ? (
                                  <div>
                                    <textarea
                                      value={editedAnswer}
                                      onChange={handleChange}
                                      rows="4"
                                      className="form-control"
                                      placeholder="Write here..."
                                    />
                                    <button
                                      onClick={() => handleSave(faq.id)}
                                      className="btn btn-primary mt-2"
                                    >
                                      Save
                                    </button>
                                  </div>
                                ) : (
                                  <div className="scrollable-container">
                                    <p>
                                      {faq.answer
                                        ? faq.answer
                                        : "Write here..."}
                                    </p>
                                    <button
                                      onClick={() => handleEdit(faq.id)}
                                      className="btn btn-secondary mt-2"
                                    >
                                      Edit
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))
                      : tabType === "story_questions" && (
                          <div className="text-center no-record-section-story">
                            <p className="font-weight-bold text-muted">
                              No record found
                            </p>
                          </div>
                        )}

                    {tabType === "story" && (
                      <div className="p-3">
                        <div className="form-group mb-4">
                          <div className="content-dashboardtab mb-2 d-flex justify-content-start">
                            <div className="d-flex gap-1 flex-column">
                              <h4>Story</h4>
                            </div>
                          </div>

                          <textarea
                            id="storyText"
                            className="form-control custom-textarea"
                            rows="6"
                            placeholder="Write your story here..."
                            value={storyText}
                            onChange={(e) => setStoryText(e.target.value)}
                          />
                        </div>

                        <div className="form-group mb-4">
                          <div className="content-dashboardtab mb-2 d-flex justify-content-start">
                            <div className="d-flex gap-1 flex-column">
                              <h4>Story Summary</h4>
                            </div>
                          </div>
                          <textarea
                            id="storySummary"
                            className="form-control custom-textarea"
                            rows="4"
                            placeholder="Write a summary of your story..."
                            value={storySummary}
                            onChange={(e) => setStorySummary(e.target.value)}
                          />
                        </div>
                        <div className="tab-dropdown-listing d-flex gap-3 align-items-center">
                          <button
                            className="custm-selct-icon-btn btn btn-primary btn-md mt-0 mr-5"
                            type="button"
                            onClick={() => {
                              if (storyText || storySummary) {
                                save_story_summary();
                              } else {
                                errorMessage("Story cannot be empty.");
                              }
                            }}
                          >
                            Save Story
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </section>
            </div>
            <div className="col-md-3 col-sm-3 mb-4 story-content ps-0">
              <div className="story-calander">
                <div className="story-cards">
                  <MiniCard cardlisting={[cardlisting[2]]} />
                </div>
                <div className="mb-4 story-min">
                  <Calendar />
                </div>
              </div>
              <div className="card-group-section">
                <div className="mb-4 viewall-stroy">
                  <ViewAll />
                </div>
                <MaskUser />
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <PricingModal
          show={true}
          onClose={() => setShowModal(false)}
          setShowModel={() => setShowModal(false)}
          backdrop="static"
          keyboard={false}
          onHide={() => setShowModal(false)}
          onCloseHitApi={() => {
            setShowModal(false);
            // dispatch(user_profile_info("", adminSelector?.user?.token));
          }}
          source={"story"}
        />
      )}
    </>
  );
};

export default Stories;
